(function () {
  if (window.__g2mCartInit) return;
  window.__g2mCartInit = true;

  var ADD_URL = (window.routes && window.routes.cartAddUrl) || '/cart/add';
  var LANG = window.languages || {};

  // Brief, accessible error state on the button, then restore so the shopper can retry.
  function showError(button, originalHTML) {
    if (!button) return;
    button.removeAttribute('disabled');
    button.removeAttribute('aria-busy');
    button.classList.remove('is-loading', 'is-added');
    button.classList.add('is-error');
    button.innerHTML = LANG.cartError || 'Try again';
    setTimeout(function () {
      button.classList.remove('is-error');
      button.innerHTML = originalHTML;
    }, 2000);
  }

  // Surfaces where g2m owns the add-to-cart: the homepage popular-products section and
  // the collection product grid (USF re-rendered cards). Both reuse the THEME cart drawer.
  function isG2mCartForm(form) {
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return false;
    return !!(
      form.closest('[data-section-type="g2m-popular-products"]') ||
      form.closest('.usf-results') ||
      form.closest('.product-list--collection')
    );
  }

  // ---- AJAX add-to-cart (single-variant). POSTs /cart/add.js then dispatches the THEME's
  //      `product:added` event so the theme's own Cart class re-renders + opens the mini-cart
  //      drawer and updates the header count. No page reload, no parallel cart UI. ----
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!isG2mCartForm(form)) return;

    event.preventDefault();
    event.stopPropagation();

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    var button = form.querySelector('[type="submit"]') || form.querySelector('button');
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var originalHTML = button ? button.innerHTML : '';

    if (button) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = LANG.productAddingShort || 'Adding…';
    }
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(ADD_URL + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: idInput.value, quantity: quantity })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (res) {
        form.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { button: button, variant: null, quantity: quantity, productAdded: res.ok }
        }));

        if (res.ok) {
          if (button) {
            button.removeAttribute('disabled');
            button.removeAttribute('aria-busy');
            button.classList.remove('is-loading');
            button.classList.add('is-added');
            button.innerHTML = LANG.productAdded || 'Added ✓';
            setTimeout(function () {
              button.classList.remove('is-added');
              button.innerHTML = originalHTML;
            }, 1600);
          }
        } else {
          showError(button, originalHTML);
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          if (window.console && res.data) console.warn('[g2m-cart] add to cart failed:', res.data.description || res.data.message);
        }
      })
      .catch(function () {
        showError(button, originalHTML);
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  }, true);

  // ---- Multi-variant cards: the grid renders a "Choose options" <a> that links to the PDP.
  //      Re-route it to the THEME's existing Quick View (variant-picker) modal so the shopper
  //      chooses a variant in-page. Reuses the card's own quick-view trigger (which carries
  //      data-product-url + aria-controls) — no parallel modal, no app-JS edits. Falls back to
  //      the link's normal navigation if no quick-view trigger is present. ----
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a.product-item__action-button');
    if (!link) return;
    if (!link.closest('.usf-results, .product-list--collection')) return;
    var form = link.closest('form');
    var quickView = form && form.querySelector('[data-secondary-action="open-quick-view"]');
    if (!quickView) return; // graceful fallback: let the link navigate to the product page
    event.preventDefault();
    event.stopPropagation();
    quickView.click();
  }, true);

  // ---- Accessibility: descriptive, product-specific aria-labels on the grid action controls.
  //      USF re-renders cards on filter/sort/load-more, so relabel (debounced) on mutation. ----
  function labelCards() {
    var cards = document.querySelectorAll('.usf-results .product-item, .product-list--collection .product-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var titleEl = card.querySelector('.product-item__title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      if (!title) continue;

      var primary = card.querySelector('form .product-item__action-button.button--primary, form a.product-item__action-button, form .product-item__action-button.button--disabled');
      if (primary && !primary.getAttribute('data-g2m-labelled')) {
        if (primary.hasAttribute('disabled') || /button--disabled/.test(primary.className)) {
          primary.setAttribute('aria-label', title + ' — sold out');
        } else if (primary.tagName === 'A') {
          primary.setAttribute('aria-label', 'Choose options for ' + title);
        } else {
          primary.setAttribute('aria-label', 'Add ' + title + ' to cart');
        }
        primary.setAttribute('data-g2m-labelled', '1');
      }

      var qv = card.querySelector('[data-secondary-action="open-quick-view"]');
      if (qv && !qv.getAttribute('data-g2m-labelled')) {
        qv.setAttribute('aria-label', 'Quick view: ' + title);
        qv.setAttribute('data-g2m-labelled', '1');
      }
    }
  }

  function initCollectionA11y() {
    var container = document.querySelector('.usf-results, .product-list--collection');
    if (!container) return; // not a collection grid page

    var timer;
    function schedule() { clearTimeout(timer); timer = setTimeout(labelCards, 120); }
    schedule();

    var target = (document.querySelector('.usf-results') || container).parentNode || document.body;
    try {
      new MutationObserver(schedule).observe(target, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionA11y);
  } else {
    initCollectionA11y();
  }
})();
